import axios from 'axios';
import { getAccessToken } from './AuthService';

const GOAL_MILESTONE_BASE =
    process.env.REACT_APP_GOAL_MILESTONE_BASE ||
    'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev';

const requestConfig = {
    headers: {
        'x-api-key':
            process.env.REACT_APP_AWS_API_GATEWAY_KEY ||
            'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB',
    },
};

function authBody(userId, extra = {}) {
    return {
        username: userId,
        token: getAccessToken(),
        ...extra,
    };
}

/**
 * Fetch milestones (and optional goal text) for Progress.
 * @returns {{ goal: string, milestones: Array }}
 */
export async function fetchGoalMilestones(userId) {
    if (!userId) return { goal: '', milestones: [] };
    try {
        const response = await axios.post(
            `${GOAL_MILESTONE_BASE}/goalmilestonefetch`,
            authBody(userId),
            requestConfig
        );
        const data = response?.data || {};
        return {
            goal: data.goal || data.textcontent || '',
            milestones: Array.isArray(data.milestones) ? data.milestones : [],
        };
    } catch (err) {
        console.error('GoalMilestoneService: fetchGoalMilestones failed', err);
        return { goal: '', milestones: [] };
    }
}

/**
 * Persist north-star user goal text (not daily goal / not /goalupdate completion).
 */
export async function saveGoal(userId, textcontent) {
    if (!userId) return;
    await axios.post(
        `${GOAL_MILESTONE_BASE}/goaltextupdate`,
        authBody(userId, { textcontent }),
        requestConfig
    );
}

/**
 * Persist full milestones array (includes done flags on check-off).
 */
export async function saveMilestones(userId, milestones) {
    if (!userId) return;
    await axios.post(
        `${GOAL_MILESTONE_BASE}/milestoneupdate`,
        authBody(userId, { milestones }),
        requestConfig
    );
}
